import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { NextIntlClientProvider, useTranslations } from "next-intl";
import { ToastProvider } from "@navi-soft/ui/toast";
import { SoftQueryProvider } from "@/lib/query/query-provider";
import { routeTree } from "./routeTree.gen";
import messagesRu from "./i18n/messages/ru.json";
import "@/styles/globals.css";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

function DeepToastProvider({ children }: { children: ReactNode }) {
  const t = useTranslations("common");
  return (
    <ToastProvider
      labels={{
        regionLabel: t("toastRegion"),
        successTitle: t("toastSuccess"),
        errorTitle: t("toastError"),
        closeAria: t("toastClose"),
      }}
    >
      {children}
    </ToastProvider>
  );
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element");
}

createRoot(rootEl).render(
  <StrictMode>
    <NextIntlClientProvider locale="ru" messages={messagesRu}>
      <SoftQueryProvider>
        <DeepToastProvider>
          <RouterProvider router={router} />
        </DeepToastProvider>
      </SoftQueryProvider>
    </NextIntlClientProvider>
  </StrictMode>,
);
